import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, del, get, put } from "../../../utils/api";
import { styled } from "@mui/material/styles";
import DateRangePickerComponent from "../../Masters/Roles and Permissions/Filters/Date";
import PaginationBox from "../../../Components/Masters/Pagination";
import DeleteDialog from "../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../Components/Masters/ColumnHeadings";
import MenuActions from "./MenuActions";
import TableContent from "../../../Components/Masters/TableContent";
import FilterDrawer from "../../../Components/Masters/FilterDrawer";
import TopMenu from "./TopMenu";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import TableHeading from "../../../Components/Masters/TableHeading";
import MenuIcon from "../../../Components/Masters/MenuIcon";
import MultiSelect from "../../Masters/Roles and Permissions/Filters/MultiSelect";
import NoDataFound from "../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../Layout/MainSidebar";
import BulkUploadModal from "../../../Components/Common/BulkUploadModal";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../context/AuthContext";
import ReceivedRequest from "./Received";
import SentRequest from "./Sent";

const CommonValuechain = () => {
  // const user = JSON.parse(localStorage.getItem("user"));
  const { user } = useUser();
  const columnHeadingsReceived = [
    {
      fieldName: "createdAt",
      title: "Date",
    },
    {
      fieldName: "partnerCompany",
      title: "Value Chain Partner",
    },
    {
      fieldName: "industry",
      title: "Industry",
    },
    {
      fieldName: "contactPersonName",
      title: "Contact Person",
    },
    {
      fieldName: "contactNumber",
      title: "Mobile",
    },
    {
      fieldName: "action",
      title: "Data Status",
    },
  ];

  const columnHeadings = [
    {
      fieldName: "createdAt",
      title: "Date",
    },
    {
      fieldName: "partnerCompany",
      title: "Value Chain Partner",
    },
    ...(user?.companyAdmin
      ? [
          {
            fieldName: "facility",
            title: "Facility",
          },
        ]
      : []),
    {
      fieldName: "industry",
      title: "Industry",
    },
    ...(!user?.companyAdmin
      ? [
          {
            fieldName: "contactPersonName",
            title: "Contact Person",
          },
        ]
      : []),
    {
      fieldName: "contactNumber",
      title: "Mobile",
    },
    {
      fieldName: "action",
      title: "Data Status",
    },
  ];

  const [pageDirection, setPageDirection] = useState("");
  const [data, setData] = useState([]);
  const [filterValue, setFilterValue] = useState("ALL");
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Industry: false,
    "Data Status": false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    Industry: false,
    Action: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    industry: [],
    action: [],
  });
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    industry: [],
    action: [],
  });
  console.log("temp", tempFilter);
  const filters = ["Date", "Industry", "Data Status"];
  const [searchQuery, setSearchQuery] = useState("");

  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [excelData, setExcelData] = useState(null);
  const [pollingInterval, setPollingInterval] = useState(null);

  useEffect(() => {
    if (!user) return;
    if (user?.companyAdmin) {
      setPageDirection("Received");
    } else if (user?.facilityManger) {
      setPageDirection("Sent");
    }
  }, [user]);
  // if (user?.companyAdmin) return null;

  const fetchUniqueValues = async () => {
    try {
      const queryParams = new URLSearchParams({
        type: pageDirection,
      }).toString();
      const response = await get(`/valueChain/request/get?${queryParams}`);

      const uniqueIndustries = response?.data?.industryList;

      const uniqueStatus = ["Accepted", "Rejected", "Pending"];

      return {
        industry: uniqueIndustries,
        action: uniqueStatus,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const fetchData = async (filters = {}, currentPage) => {
    try {
      const filterParams =
        filterValue !== "ALL"
          ? { ...filters, direction: filterValue }
          : filters;
      console.log("temp12", filterParams, tempFilter);
      const queryParams = new URLSearchParams({
        ...filterParams,
        page: currentPage || page,
        limit: rowsPerPage,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
        type:
          pageDirection?.length < 0
            ? pageDirection
            : user?.companyAdmin === true
            ? "Received"
            : "Sent",
        search: searchQuery,
        userType: filterValue,
      }).toString();
      const response = await get(`/valueChain/request/get?${queryParams}`);
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(filtersToApply, page);
  }, [page, rowsPerPage, sortConfig, searchQuery, filterValue]);

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);

  useEffect(() => {
    let arr = [
      {
        "S No.": "",
        "Month (in 01/25 or Jan-25)": "",
        "Value Chain Partner Name": "",
        "Natural Gas Emission (in tCO2e)": "",
        "Coal Emission (in tCO2e)": "",
        "Petrol Emission (in tCO2e)": "",
        "Diesel Emission (in tCO2e)": "",
        "Fuel Emission (in tCO2e)": "",
        "LPG Emission (in tCO2e)": "",
        "Propane Emission (in tCO2e)": "",
        "OnRoad Emission (in tCO2e)": "",
        "OFRoad Emission (in tCO2e)": "",
        "Refrigeration Emission (in tCO2e)": "",
        "Extinguisher Emission (in tCO2e)": "",
        "Electricity Emission (in tCO2e)": "",
        "Heat Emission (in tCO2e)": "",
        "Steam Emission (in tCO2e)": "",
        "Purchase Goods (in tCO2e)": "",
        "Transportation Emission (in tCO2e)": "",
        "Employee Commute (in tCO2e)": "",
        "Waste Generated (in tCO2e)": "",
        "Business Travel (in tCO2e)": "",
      },
    ];

    setExcelData(arr);
  }, []);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleDeleteAggree = async () => {
    try {
      const res = await del(`/valueChain/request/get/${element._id}`);
      setDeleteDialog(false);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      fetchData();
    } catch (err) {
      console.log(err);
      setsnackOpen({
        open: true,
        message: err.data?.response.message ?? "network Error",
        severity: "error",
      });
    }
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    industry: tempFilter?.industry?.length
      ? tempFilter?.industry.join(",")
      : "",
    action: tempFilter?.action?.length ? tempFilter?.action.join(",") : "",
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    fetchData(filtersToApply, 1);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      industry: tempFilter?.industry,
      action: tempFilter?.action,
    });
    setPage(1);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setTempFilter({
      startDate: null,
      endDate: null,
      industry: [],
      action: [],
    });
    setStartDate(null);
    setEndDate(null);
    setSelectedFields({
      industry: [],
      action: [],
    });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isIndustryApplied = tempFilter.industry?.length > 0 ? true : false;

    const isStatusApplied = tempFilter?.action?.length > 0 ? true : false;

    setIsFiltersApplied(isDateApplied || isIndustryApplied || isStatusApplied);

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Industry: isIndustryApplied,
      "Data Status": isStatusApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    console.log("123", new Date(), filtersToApply);
    setSortConfig({ key: column, direction });
    fetchData(filtersToApply, 1);
  };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      industry: selectedFields?.industry,
      action: selectedFields.action,
    });
    setDrawerFilterOpen(false);
  };

  const handleAction = async (actionType, id) => {
    try {
      const response = await put(`/valueChain/request/update/?Id=${id}`, {
        action: actionType,
      });
      fetchData();
      setData((prevData) =>
        prevData.map((item) =>
          item._id === id ? { ...item, action: actionType } : item
        )
      );
    } catch (error) {
      console.error("Failed to update action:", error);
    }
  };

  const bulkUploadCallback = async () => {
    await fetchData();
  };

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      case "Industry":
        return (
          <MultiSelect
            title="Industry"
            url={`${api}/valueChain/partner/get`}
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  industry: newValue.industry || newValue,
                };
              });
            }}
            errors={errors.Industry}
            setErrors={setErrors}
            field="industry"
            data={uniqueValues.industry}
          />
        );

      case "Data Status":
        return (
          <MultiSelect
            title="Data Status"
            url={`${api}/valueChain/partner/get`}
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  action: newValue.action || newValue,
                };
              });
            }}
            errors={errors.Status}
            setErrors={setErrors}
            field="action"
            data={uniqueValues.action}
          />
        );

      default:
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
    }
  };

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
  };
  return (
    <MainDashboardLayout sidebar={<MainSidebar />}>
      <Unauthorized requiredModule="Value Chain | Request">
        <>
          <Box
            sx={{
              // padding: "20px",
              backgroundColor: "#ededed",
              width: "100%",
            }}
          >
            <MessagePopup {...{ snackOpen, setsnackOpen }} />

            <TopMenu
              setData={setElement}
              setAddData={setAddData}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              setFilterValue={setFilterValue}
              {...{
                heading: "Value Chain",
                setDrawerFilterOpen,
                filterApplied: isFiltersApplied,
              }}
              pageDirection={
                pageDirection === "Sent"
                  ? "Sent"
                  : pageDirection === "Received"
                  ? "Received"
                  : null
              }
            />
            {deleteDialog && (
              <DeleteDialog
                {...{ deleteDialog, setDeleteDialog, handleDeleteAggree }}
              />
            )}
            {/* Filter Drawer */}
            {drawerFilterOpen && (
              <FilterDrawer
                {...{
                  renderSelectedFilter,
                  drawerFilterOpen,
                  setDrawerFilterOpen,
                  handleApplyFilters,
                  handleFilterDrawer,
                  setSelectedFilter,
                  handleResetFilters,
                  selectedFilter,
                  filters,
                  appliedFilters,
                  selectedFields,
                  setSelectedFields,
                }}
              />
            )}
            {pageDirection === "Sent" ? (
              <SentRequest
                /* data to show */
                data={data}
                columnHeadings={columnHeadings}
                user={user}
                /* state */
                page={page}
                totalPages={totalPages}
                rowsPerPage={rowsPerPage}
                sortConfig={sortConfig}
                /* callbacks */

                onPageChange={(_, newPage) => setPage(newPage)}
                /* others the child still needs */
                handleMenuClick={handleMenuClick}
                isShortContent={isShortContent}
                bulkUploadCallback={bulkUploadCallback}
                handleSort={handleSort}
              />
            ) : pageDirection === "Received" ? (
              <ReceivedRequest
                data={data}
                columnHeadings={columnHeadingsReceived}
                user={user}
                /* state */
                page={page}
                totalPages={totalPages}
                rowsPerPage={rowsPerPage}
                sortConfig={sortConfig}
                /* callbacks */

                onPageChange={(_, newPage) => setPage(newPage)}
                /* others the child still needs */
                handleMenuClick={() => console.log("he")}
                isShortContent={isShortContent}
                handleAction={handleAction}
                handleSort={handleSort}
              />
            ) : null}
          </Box>
        </>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default CommonValuechain;
